<template><div><h1 id="exportfelder" tabindex="-1"><a class="header-anchor" href="#exportfelder"><span>Exportfelder</span></a></h1>
<p>Exportfelder — Definiert Exportfelder</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden alle verfügbaren Exportfelder angezeigt, welche in einem <RouteLink to="/referenz/refs/ft.refdata.exportformat.html" title="Exportformate">Exportformat</RouteLink> zugeordnet werden können. Neben den herkömmlich hardcodierten Exportfeldern, gibt es auch &quot;parametrisierbare Exportfelder&quot;, in denen Referenzwerte eingetragen werden können.</p>
<p>Z.B. im Exportfeld 14 &quot;Umsatz im Jahr: Umsatztyp: &quot; kann das Jahr und der Umsatztyp frei definiert werden. Zudem ist die Anwendung von Referenzwerten möglich, so dass z.B. das Feld &quot;Jahr&quot; immer mit dem aktuellen Jahr gefüllt wird. Die Referenzwerte werden im <RouteLink to="/referenz/refs/ft.refdata.exportformat.html" title="Exportformate">Exportformat</RouteLink> definiert.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Exportformate → Exportfelder</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr.</dt>
<dd>Nummer des Exportfeldes, eindeutige Identifikation des Exportfeldes.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Exportfeldes.</dd>
<dt>Typ</dt>
<dd>Typ des Exportfeldes (Text, Datum, etc.)</dd>
<dt>Dokumentation (unteres Frame)</dt>
<dd>Hinweise.</dd>
</dl>
<h2 id="exportfelder-1" tabindex="-1"><a class="header-anchor" href="#exportfelder-1"><span>Exportfelder</span></a></h2>
<p>Zusammenfassung der Exportfelder.</p>
<p><strong>Tabelle 38. Exportfelder</strong></p>
<table>
<thead>
<tr>
<th>Feld</th>
<th>ID</th>
<th>Beschreibung</th>
<th>Kategorie</th>
<th>Erklärung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ADR1-BEMERK1</td>
<td>1</td>
<td>Person - Notizen</td>
<td>Text</td>
<td>Notizen aus Personenansicht, ohne Zeilenumbrüche</td>
</tr>
<tr>
<td>ADR1-FUNKTION</td>
<td>2</td>
<td>Person - Funktion</td>
<td>Text</td>
<td>Funktion der Person (aus Stammtabelle)</td>
</tr>
<tr>
<td>ADR1-FUNKTIONBEZ</td>
<td>3</td>
<td>Person - Funktionsbezeichnung</td>
<td>Text</td>
<td>Manuell erfasster Wert resp. Funktion aus Stammtabelle wenn dieser fehlt</td>
</tr>
<tr>
<td>ADRESSANREDE1</td>
<td>4</td>
<td>Adressanrede - Standard</td>
<td>Text</td>
<td>Adresse - Adressanrede</td>
</tr>
<tr>
<td>ADRESSANREDE1.1</td>
<td>5</td>
<td>Adressanrede - bis 18 Jahre alt leer (** veraltet, 4 ist zu benutzen und richtige Anredeparametrisierung)</td>
<td>Text</td>
<td>Adressanrede mit Eintrag erst ab Alter &gt; 19 Jahre</td>
</tr>
<tr>
<td>ANREDE-Z1</td>
<td>6</td>
<td>Adressanrede - Zeile 1</td>
<td>Text</td>
<td>1. Zeile von mehrzeiliger Adressanrede</td>
</tr>
<tr>
<td>ANREDE-Z2</td>
<td>7</td>
<td>Adressanrede - Zeile 2</td>
<td>Text</td>
<td>2. Zeile von mehrzeiliger Adressanrede</td>
</tr>
<tr>
<td>ANREDE-Z3</td>
<td>8</td>
<td>Adressanrede - Zeile 3</td>
<td>Text</td>
<td>3. Zeile von mehrzeiliger Adressanrede</td>
</tr>
<tr>
<td>ADRESSANREDE2</td>
<td>9</td>
<td>Adressanrede Person 2</td>
<td>Text</td>
<td>Standard-Adressanrede für Person 2</td>
</tr>
<tr>
<td>ADRESSTYP1</td>
<td>10</td>
<td>Personentyp</td>
<td>Text</td>
<td>Personentyp (P = privat, F = Organisation, K = Kontaktperson)</td>
</tr>
<tr>
<td>ADRESSTYP2</td>
<td>11</td>
<td>Person 2 - Typ</td>
<td>Text</td>
<td>Personentyp von Person 2 (P = privat, F = Organisation, K = Kontaktperson)</td>
</tr>
<tr>
<td>ADRNUM1</td>
<td>12</td>
<td>Person - ID</td>
<td>IntZahl</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>ADRNUM2</td>
<td>13</td>
<td>Person 2 - ID</td>
<td>IntZahl</td>
<td>Personen-ID von Person 2</td>
</tr>
<tr>
<td>Adressumsatz</td>
<td>14</td>
<td>Umsatz - im Jahr: {1}, Umsatztyp: {2}</td>
<td>Zahl</td>
<td>Umsatz, berechnet pro Jahr (leer = über alle Jahre) und Umsatztyp (Mehrfachauswahl möglich, * = alle Typen)</td>
</tr>
<tr>
<td>ADRUMS1-VORJAHR1</td>
<td>15</td>
<td>Umsatz - VJ Umsatzyp aus Ereignis 1</td>
<td>Zahl</td>
<td>Vorjahresumsatz (Jahr = aktuelles Jahr -1), Umsatztyp aus Ereignis 1 übernommen, Lifetime-Umsatz wenn Ereignis 1 fehlt</td>
</tr>
<tr>
<td>ADRUMS1-VORJAHR2</td>
<td>16</td>
<td>Umsatz - VJ Umsatzyp aus Ereignis 2</td>
<td>Zahl</td>
<td>Vorjahresumsatz (Jahr = aktuelles Jahr -1), Umsatztyp aus Ereignis 2 übernommen, Lifetime-Umsatz wenn Ereignis 2 fehlt</td>
</tr>
<tr>
<td>ADRUMS11-VORJAHR1</td>
<td>17</td>
<td>Umsatz - VJ Umsatzyp aus Ereignis 1, wenn vorhanden</td>
<td>Zahl</td>
<td>Vorjahresumsatz (Jahr = aktuelles Jahr -1), Umsatztyp aus Ereignis 1 übernommen, 0.00 Umsatz wenn Ereignis 1 fehlt</td>
</tr>
<tr>
<td>ADRUMSVJ1-SPE+WWF</td>
<td>18</td>
<td>Umsatz - VJ von Umsatztypen WWF + SPE (** veraltet)</td>
<td>Zahl</td>
<td>** Exportfeld 14 benutzen! Vorjahresumsatz (Jahr = aktuelles Jahr -1), Umsatztypen WWF + SPE (hardcodiert)</td>
</tr>
<tr>
<td>ADRZEILE11_1</td>
<td>19</td>
<td>Adresse - Adresszeile1 6x35, ohne Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile1 6x35, ohne Funktion</td>
</tr>
<tr>
<td>ADRZEILE11_2</td>
<td>20</td>
<td>Adresse - Adresszeile2 6x35, ohne Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile2 6x35, ohne Funktion</td>
</tr>
<tr>
<td>ADRZEILE11_3</td>
<td>21</td>
<td>Adresse - Adresszeile3 6x35, ohne Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile3 6x35, ohne Funktion</td>
</tr>
<tr>
<td>ADRZEILE11_4</td>
<td>22</td>
<td>Adresse - Adresszeile4 6x35, ohne Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile4 6x35, ohne Funktion</td>
</tr>
<tr>
<td>ADRZEILE11_5</td>
<td>23</td>
<td>Adresse - Adresszeile5 6x35, ohne Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile5 6x35, ohne Funktion</td>
</tr>
<tr>
<td>ADRZEILE11_6</td>
<td>24</td>
<td>Adresse - Adresszeile6 6x35, ohne Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile6 6x35, ohne Funktion</td>
</tr>
<tr>
<td>ADRZEILE1_1</td>
<td>25</td>
<td>Adresse - Adresszeile1 6x32, mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile1 6x32, mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE1_2</td>
<td>26</td>
<td>Adresse - Adresszeile2 6x32, mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile2 6x32, mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE1_3</td>
<td>27</td>
<td>Adresse - Adresszeile3 6x32, mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile3 6x32, mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE1_4</td>
<td>28</td>
<td>Adresse - Adresszeile4 6x32, mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile4 6x32, mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE1_5</td>
<td>29</td>
<td>Adresse - Adresszeile5 6x32, mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile5 6x32, mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE1_6</td>
<td>30</td>
<td>Adresse - Adresszeile6 6x32, mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile6 6x32, mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE2_1</td>
<td>31</td>
<td>2. Adresse - Adresszeile1</td>
<td>Text</td>
<td>2. Adresse - Adresszeile1</td>
</tr>
<tr>
<td>ADRZEILE2_2</td>
<td>32</td>
<td>2. Adresse - Adresszeile2</td>
<td>Text</td>
<td>2. Adresse - Adresszeile2</td>
</tr>
<tr>
<td>ADRZEILE2_3</td>
<td>33</td>
<td>2. Adresse - Adresszeile3</td>
<td>Text</td>
<td>2. Adresse - Adresszeile3</td>
</tr>
<tr>
<td>ADRZEILE2_4</td>
<td>34</td>
<td>2. Adresse - Adresszeile4</td>
<td>Text</td>
<td>2. Adresse - Adresszeile4</td>
</tr>
<tr>
<td>ADRZEILE2_5</td>
<td>35</td>
<td>2. Adresse - Adresszeile5</td>
<td>Text</td>
<td>2. Adresse - Adresszeile5</td>
</tr>
<tr>
<td>ADRZEILE2_6</td>
<td>36</td>
<td>2. Adresse - Adresszeile6</td>
<td>Text</td>
<td>2. Adresse - Adresszeile6</td>
</tr>
<tr>
<td>ADRZEILE_UNB_1</td>
<td>37</td>
<td>Adresse - Adresszeile1 6x(unbegrenzt), mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile1 6x(unbegrenzt), mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE_UNB_2</td>
<td>38</td>
<td>Adresse - Adresszeile2 6x(unbegrenzt), mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile2 6x(unbegrenzt), mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE_UNB_3</td>
<td>39</td>
<td>Adresse - Adresszeile3 6x(unbegrenzt), mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile3 6x(unbegrenzt), mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE_UNB_4</td>
<td>40</td>
<td>Adresse - Adresszeile4 6x(unbegrenzt), mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile4 6x(unbegrenzt), mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE_UNB_5</td>
<td>41</td>
<td>Adresse - Adresszeile5 6x(unbegrenzt), mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile5 6x(unbegrenzt), mit Funktion</td>
</tr>
<tr>
<td>ADRZEILE_UNB_6</td>
<td>42</td>
<td>Adresse - Adresszeile6 6x(unbegrenzt), mit Funktion</td>
<td>Text</td>
<td>Adresse - Adresszeile6 6x(unbegrenzt), mit Funktion</td>
</tr>
<tr>
<td>ANDAT</td>
<td>43</td>
<td>Korrespondenz - Erfassungsdatum</td>
<td>Datum</td>
<td>Erfassungsdatum der Korrespondenz</td>
</tr>
<tr>
<td>ANID</td>
<td>44</td>
<td>Korrespondenz - Erfasser</td>
<td>Text</td>
<td>Erfasser der Korrespondenz</td>
</tr>
<tr>
<td>ANLASS1_ART</td>
<td>45</td>
<td>Anlass - Art</td>
<td>Text</td>
<td>Anlassart des exportierten Anlasses</td>
</tr>
<tr>
<td>ANLASS1_BETREUER</td>
<td>46</td>
<td>Anlass - Betreuer</td>
<td>Text</td>
<td>Betreuer des exportierten Anlasses</td>
</tr>
<tr>
<td>ANLASS1_B_ADRNUM</td>
<td>47</td>
<td>Anlass - B Personen-ID (** veraltet)</td>
<td>IntZahl</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ANLASS1_B_ANREDE</td>
<td>48</td>
<td>Anlass - B Anrede (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ANLASS1_B_NAME</td>
<td>49</td>
<td>Anlass - B Name (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ANLASS1_B_TITEL</td>
<td>50</td>
<td>Anlass - B Titel (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ANLASS1_B_VORNAME</td>
<td>51</td>
<td>Anlass - B Vorname (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ANLASS1_ERFASSDAT</td>
<td>52</td>
<td>Anlass - Erfassungsdatum</td>
<td>Datum</td>
<td>Erfassungsdatum des exportierten Anlasses</td>
</tr>
<tr>
<td>ANLASS1_KADRZEIL1</td>
<td>53</td>
<td>Anlass - Kontaktperson Adresszeile 1</td>
<td>Text</td>
<td>Postalische Adresse der Anlass-Kontaktperson, Zeile 1</td>
</tr>
<tr>
<td>ANLASS1_KADRZEIL2</td>
<td>54</td>
<td>Anlass - Kontaktperson Adresszeile 2</td>
<td>Text</td>
<td>Postalische Adresse der Anlass-Kontaktperson, Zeile 2</td>
</tr>
<tr>
<td>ANLASS1_KADRZEIL3</td>
<td>55</td>
<td>Anlass - Kontaktperson Adresszeile 3</td>
<td>Text</td>
<td>Postalische Adresse der Anlass-Kontaktperson, Zeile 3</td>
</tr>
<tr>
<td>ANLASS1_KADRZEIL4</td>
<td>56</td>
<td>Anlass - Kontaktperson Adresszeile 4</td>
<td>Text</td>
<td>Postalische Adresse der Anlass-Kontaktperson, Zeile 4</td>
</tr>
<tr>
<td>ANLASS1_KADRZEIL5</td>
<td>57</td>
<td>Anlass - Kontaktperson Adresszeile 5</td>
<td>Text</td>
<td>Postalische Adresse der Anlass-Kontaktperson, Zeile 5</td>
</tr>
<tr>
<td>ANLASS1_KADRZEIL6</td>
<td>58</td>
<td>Anlass - Kontaktperson Adresszeile 6</td>
<td>Text</td>
<td>Postalische Adresse der Anlass-Kontaktperson, Zeile 6</td>
</tr>
<tr>
<td>ANLASS1_K_ADRNUM</td>
<td>59</td>
<td>Anlass - Kontaktperson Personen-ID</td>
<td>IntZahl</td>
<td>Personen-ID der Anlass-Kontaktperson</td>
</tr>
<tr>
<td>ANLASS1_K_ANREDE</td>
<td>60</td>
<td>Anlass - Kontaktperson Anrede</td>
<td>Text</td>
<td>Anrede der Anlass-Kontaktperson</td>
</tr>
<tr>
<td>ANLASS1_K_NAME</td>
<td>61</td>
<td>Anlass - Kontaktperson Name</td>
<td>Text</td>
<td>Nachname der Anlass-Kontaktperson</td>
</tr>
<tr>
<td>ANLASS1_K_TITEL</td>
<td>62</td>
<td>Anlass - Kontaktperson Titel</td>
<td>Text</td>
<td>Titel der Anlass-Kontaktperson</td>
</tr>
<tr>
<td>ANLASS1_K_VORNAME</td>
<td>63</td>
<td>Anlass - Kontaktperson Vorname</td>
<td>Text</td>
<td>Vorname der Anlass-Kontaktperson</td>
</tr>
<tr>
<td>ANLASS1_RESADR</td>
<td>64</td>
<td>Anlass - Response-Adressen</td>
<td>Text</td>
<td>6 Zeilen mit Komma getrennt, ganze Zeile in doppelten Anführungszeichen</td>
</tr>
<tr>
<td>ANLASS1_RESLAUF</td>
<td>65</td>
<td>Anlass - Responswert Verdankung</td>
<td>Zahl</td>
<td>Summe aller verdankten Spenden aus dem aktuellen Verdankungsjob</td>
</tr>
<tr>
<td>ANLASS1_RESWERT</td>
<td>66</td>
<td>Anlass - Responsewert Total</td>
<td>Zahl</td>
<td>Summe aller Responswerte des verdankten Anlasses</td>
</tr>
<tr>
<td>ANREDECODE1</td>
<td>68</td>
<td>Person - Anredecode</td>
<td>Text</td>
<td>Anrede-Code (aus Stammtabelle)</td>
</tr>
<tr>
<td>ANREDECODE2</td>
<td>69</td>
<td>Person 2 - Anredecode</td>
<td>Text</td>
<td>Anrede-Code der Person 2 (aus Stammtabelle)</td>
</tr>
<tr>
<td>BETRAG1A</td>
<td>70</td>
<td>Zusagenfakturierung - Zusagebetrag als Text</td>
<td>Text</td>
<td>Zusagebetrag im Textformat, z. Bsp. -.-- oder 100.--</td>
</tr>
<tr>
<td>BETRAG1N</td>
<td>71</td>
<td>Zusagenfakturierung - Zusagebetrag dezimal</td>
<td>Zahl</td>
<td>Zusagebetrag dezimal, z. B. 0.00 oder 100.00</td>
</tr>
<tr>
<td>BETRAG1N-X</td>
<td>72</td>
<td>Zusagenfakturierung - Zusagebetrag gekreuzt wenn 0.00</td>
<td>Text</td>
<td>Zusagebetrag mit spezielllem Output wenn Betrag 0.00 ist, z. B. XXXXXXX oder 100</td>
</tr>
<tr>
<td>BETRAG1N.1</td>
<td>73</td>
<td>Zusagenfakturierung - Zusagebetrag ohne Formatierung</td>
<td>Zahl</td>
<td>Zusagebetrag ohne Formatierung, z. B. 0 oder 100</td>
</tr>
<tr>
<td>BETRAG1N.2</td>
<td>74</td>
<td>Zusagenfakturierung - Zusagebetrag dezimal max 12 Z. (** veraltet)</td>
<td>Zahl</td>
<td>** nicht mehr verwenden (veraltet): Zusagebetrag dezimal, z. B. 0.00 oder 100.00 (max. Länge 12 Zeichen)</td>
</tr>
<tr>
<td>BETRAG2A</td>
<td>75</td>
<td>Zusagenfakturierung - Spendenbetrag als Text</td>
<td>Text</td>
<td>Spendenbetrag im Textformat, z. Bsp. -.-- oder 100.--</td>
</tr>
<tr>
<td>BETRAG2N</td>
<td>76</td>
<td>Zusagenfakturierung - Spendenbetrag dezimal</td>
<td>Zahl</td>
<td>Spendenbetrag dezimal, z. B. 0.00 oder 100.00</td>
</tr>
<tr>
<td>BETRAG2N-OF</td>
<td>77</td>
<td>Zusagenfakturierung - Spendenbetrag ohne Formatierung</td>
<td>Zahl</td>
<td>Spendenbetrag ohne Formatierung, z. B. 0 oder 100</td>
</tr>
<tr>
<td>BEZIRK</td>
<td>79</td>
<td>Person - Region der Regionengruppe {1}</td>
<td>Text</td>
<td>Geographische Region der Standardadresse, welche in Regionengruppe {1} definiert ist</td>
</tr>
<tr>
<td>BRANCHEN1</td>
<td>80</td>
<td>Organisation - Branche</td>
<td>Text</td>
<td>Branche einer Organisation/Kontaktperson</td>
</tr>
<tr>
<td>BRANCHENBEZ1</td>
<td>81</td>
<td>Organisation - Branchenbezeichnung</td>
<td>Text</td>
<td>Bezeichnung der Branche einer Organisation/Kontaktperson</td>
</tr>
<tr>
<td>Adressumsatz</td>
<td>82</td>
<td>Umsatz - Umsatztyp: {1}, Datum: {2} - {3}</td>
<td>Zahl</td>
<td>Umsatz im Zeitraum, Umsatztyp (Mehrfachauswahl möglich mit Komma trennen, * = alle Typen)</td>
</tr>
<tr>
<td>BRIEFANREDE1</td>
<td>83</td>
<td>Briefanrede einzeilig oder mehrzeilig, {1}</td>
<td>Text</td>
<td>Briefanrede, optional in einer Zeile (kommagetrennt) oder mit Zeilenumbrüchen (für HH und GA geeignet)</td>
</tr>
<tr>
<td>BRIEFANREDE-Z1</td>
<td>85</td>
<td>Briefanrede 1. Zeile (von mehrzeiliger Anrede)</td>
<td>Text</td>
<td>1. Zeile von mehrzeiliger Briefanrede (für HH und GA geeignet)</td>
</tr>
<tr>
<td>BRIEFANREDE-Z2</td>
<td>86</td>
<td>Briefanrede 2. Zeile (von mehrzeiliger Anrede)</td>
<td>Text</td>
<td>2. Zeile von mehrzeiliger Briefanrede (für HH und GA geeignet)</td>
</tr>
<tr>
<td>BRIEFANREDE-Z3</td>
<td>87</td>
<td>Briefanrede 3. Zeile (von mehrzeiliger Anrede)</td>
<td>Text</td>
<td>3. Zeile von mehrzeiliger Briefanrede (für HH und GA geeignet)</td>
</tr>
<tr>
<td>BRIEFANREDE1.2</td>
<td>88</td>
<td>Briefanrede, nur erster Namensteil vor '-'. (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>BRIEFANREDE2</td>
<td>89</td>
<td>Briefanrede Person 2</td>
<td>Text</td>
<td>Briefanrede von Person 2, in Anführungszeichen</td>
</tr>
<tr>
<td>BRIEFDATUM</td>
<td>90</td>
<td>Zusagenfakturierung - Briefdatum</td>
<td>Datum</td>
<td>Briefdatum aus Zusagenfakturierung</td>
</tr>
<tr>
<td>CR</td>
<td>91</td>
<td>Festwert - CR</td>
<td>Sys</td>
<td>Steuerzeichen &quot;carriage return&quot;</td>
</tr>
<tr>
<td>DATAMATRIX_PP20</td>
<td>92</td>
<td>Datamatrix: Absenderreferenz {1}, Verarbeitung {2}, Rücksendungen {3}, Referenz {4}</td>
<td>Text</td>
<td>Datamatrix PP-Frankierung Typ 20</td>
</tr>
<tr>
<td>DOKUMENT-CODE</td>
<td>93</td>
<td>Dokumentencode</td>
<td>Text</td>
<td>Dokumentencode</td>
</tr>
<tr>
<td>DOKUMENT-CODE-KLEIN</td>
<td>94</td>
<td>Dokumentencode (Kleinbuchstaben)</td>
<td>Text</td>
<td>Dokumentencode in Kleinbuchstaben</td>
</tr>
<tr>
<td>DOKUMENTENSATZ</td>
<td>95</td>
<td>Dokumentensatz</td>
<td>Text</td>
<td>Dokumentensatz</td>
</tr>
<tr>
<td>EREIG-KANAL1</td>
<td>96</td>
<td>Ereignis - Kanal</td>
<td>Text</td>
<td>Kanaleintrag des Ereignisses</td>
</tr>
<tr>
<td>EREIG-KEINTRAG1</td>
<td>97</td>
<td>Ereignis - Adresseintrag</td>
<td>Text</td>
<td>Adresseintrag zum Ereignis (Standrdadresse zum Kanal oder explizit ausgewählte Adresse)</td>
</tr>
<tr>
<td>EREIGKPF1_BEZ</td>
<td>98</td>
<td>Ereignis - Beschreibung</td>
<td>Text</td>
<td>Beschreibungstext vom Ereignis</td>
</tr>
<tr>
<td>EREIGKPF1_PROJBEZ</td>
<td>99</td>
<td>Ereignis - Projektbezeichnung</td>
<td>Text</td>
<td>Bezeichnung des mit dem Ereigns verknüpften Projektes</td>
</tr>
<tr>
<td>EREIGKPF1_PROJNR</td>
<td>100</td>
<td>Ereignis - Projekt</td>
<td>Text</td>
<td>Das mit dem Ereignis verknüpfte Projekt</td>
</tr>
<tr>
<td>EREIGKPF1_UMSTYP</td>
<td>101</td>
<td>Ereignis - Umsatztyp</td>
<td>Text</td>
<td>Umsatztyp des Ereignisses</td>
</tr>
<tr>
<td>EREIGNIS1</td>
<td>102</td>
<td>Ereignis - Interne Nummer</td>
<td>IntZahl</td>
<td>Interne Nummer des Ereignisses</td>
</tr>
<tr>
<td>EREIGNIS1CHAR</td>
<td>103</td>
<td>Ereignis - ID</td>
<td>Text</td>
<td>ID/Bezeichnung des Ereignisses</td>
</tr>
<tr>
<td>EREIGNIS2</td>
<td>104</td>
<td>Ereignis 2 - Interne Nummer</td>
<td>IntZahl</td>
<td>Interne Nummer des 2. Ereignisses</td>
</tr>
<tr>
<td>EREIGNIS2CHAR</td>
<td>105</td>
<td>Ereignis 2 - ID</td>
<td>Text</td>
<td>ID/Ereignisbezeichnung des 2. Ereignisses</td>
</tr>
<tr>
<td>EREIGPOS1</td>
<td>106</td>
<td>Ereignisposition - Interne Nummer</td>
<td>IntZahl</td>
<td>Interne Nummer der Ereignisposition</td>
</tr>
<tr>
<td>EREIGPOS1CHAR</td>
<td>107</td>
<td>Ereignisposition - ID</td>
<td>Text</td>
<td>ID/Bezeichnung der Ereignisposition</td>
</tr>
<tr>
<td>EREIGPOS1_BEZ</td>
<td>108</td>
<td>Ereignisposition - Beschreibung</td>
<td>Text</td>
<td>Beschreibungstext der Ereignisposition</td>
</tr>
<tr>
<td>EREIGPOS2</td>
<td>109</td>
<td>Ereignisposition 2 - Interne Nummer</td>
<td>IntZahl</td>
<td>Interne Nummer der Ereignisposition von Ereignis 2</td>
</tr>
<tr>
<td>EREIGPOS2CHAR</td>
<td>110</td>
<td>Ereignisposition 2 - ID</td>
<td>Text</td>
<td>ID/Ereignisbezeichnung der Position des des 2. Ereignisses</td>
</tr>
<tr>
<td>EREIGR</td>
<td>111</td>
<td>Korrespondenz - Responsereignis (** veraltet)</td>
<td>IntZahl</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ERPNRR</td>
<td>112</td>
<td>Korrespondenz - Responsereignispos. (** veraltet)</td>
<td>IntZahl</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>EREIGTEXT-KORR_KOPF</td>
<td>113</td>
<td>Ereignis - Ereignistext Korrespondenz</td>
<td>Text</td>
<td>Ereignisstext von Ereignis mit Verwendung &quot;Korrespondenz&quot;</td>
</tr>
<tr>
<td>EREIGTEXT-KORR_POS</td>
<td>114</td>
<td>Ereignisposition - Ereignistext Korrespondenz</td>
<td>Text</td>
<td>Ereignisstext von Ereignisposition mit Verwendung &quot;Korrespondenz&quot;</td>
</tr>
<tr>
<td>EREIGTEXT-VERD_KOPF</td>
<td>115</td>
<td>Ereignis - Ereignistext Verdankung</td>
<td>Text</td>
<td>Ereignisstext von Ereignis mit Verwendung &quot;Verdankung&quot;</td>
</tr>
<tr>
<td>EREIGTEXT-VERD_POS</td>
<td>116</td>
<td>Ereignisposition - Ereignistext Verdankung</td>
<td>Text</td>
<td>Ereignisstext von Ereignisposition mit Verwendung &quot;Verdankung&quot;</td>
</tr>
<tr>
<td>EREIGTEXT-WEB_KOPF</td>
<td>117</td>
<td>Ereignis - Ereignistext WEB</td>
<td>Text</td>
<td>Ereignisstext von Ereignis mit Verwendung &quot;WEB&quot;</td>
</tr>
<tr>
<td>EREIGTEXT-WEB_POS</td>
<td>118</td>
<td>Ereignisposition - Ereignistext WEB</td>
<td>Text</td>
<td>Ereignisstext von Ereignisposition mit Verwendung &quot;WEB&quot;</td>
</tr>
<tr>
<td>ESR-ID1</td>
<td>120</td>
<td>ESR-ID Ereignisposition</td>
<td>Text</td>
<td>ESR-ID der Ereignisposition. ESR-ID ist für interne Verwendung gedacht, kann aber zur Steuerung der Briefvarianten verwendet werden (z.B. bei Mailings).</td>
</tr>
<tr>
<td>QR-Rechnung Daten</td>
<td>125</td>
<td>QR-Rechnung {1}: {2}</td>
<td>Text</td>
<td>Exportiert wahlweise Konto oder Referenz {1} für das n-te Segmentereignis {2}. Ob ein Paar QR-IBAN/QR-Referenz oder IBAN/Creditor Reference (SCOR) exportiert wird, wird durch die Parametrisiering in der Ereignistabelle definiert (ESR-Teilnehmernummer). Beim Export der Zusagefakturierung gilt das erste Ereignis als Zusageereignis, das zweite als optionaler Spendenereignis.</td>
</tr>
<tr>
<td>ESR1.2</td>
<td>128</td>
<td>ESR-Zeile1 (aus Ereignis1, Ereignisposition1, Betrag1, H am Ende), wenn Ereig existiert und ESR-Teilnehmernummer &gt; 0 (** veraltet)</td>
<td>Text</td>
<td>ESR-Zeile1 (aus Ereignis1, Ereignisposition1, Betrag1, H am Ende), wenn Ereig existiert und ESR-Teilnehmernummer &gt; 0, ** nicht mehr verwenden (veraltet) siehe 432 ESR-Feld</td>
</tr>
<tr>
<td>ESR1.3</td>
<td>129</td>
<td>ESR-Zeile1 (aus Ereignis1, Ereignisposition1, Betrag1, leer an Ende) - ohne ersten 10 Zeichen (** veraltet)</td>
<td>Text</td>
<td>ESR-Zeile1 (aus Ereignis1, Ereignisposition1, Betrag1, leer an Ende) - ohne ersten 10 Zeichen, ** nicht mehr verwenden (veraltet) siehe 432 ESR-Feld</td>
</tr>
<tr>
<td>EXTRA-DATUM-1</td>
<td>142</td>
<td>Korrespondenz - Datum</td>
<td>Datum</td>
<td>Datumfeld aus Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-1</td>
<td>143</td>
<td>Extra Text 1 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 1 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-2</td>
<td>144</td>
<td>Extra Text 2 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 2 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-3</td>
<td>145</td>
<td>Extra Text 3 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 3 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-4</td>
<td>146</td>
<td>Extra Text 4 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 4 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-5</td>
<td>427</td>
<td>Extra Text 5 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 5 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-6</td>
<td>428</td>
<td>Extra Text 6 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 6 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-TEXT-7</td>
<td>429</td>
<td>Extra Text 7 aus z.B. Korrespondenz</td>
<td>Text</td>
<td>Extra Text 7 aus z.B. Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-ZAHL-1</td>
<td>147</td>
<td>Korrespondenz - Zahl 1</td>
<td>Zahl</td>
<td>Zahl 1 aus Korrespondenz</td>
</tr>
<tr>
<td>EXTRA-ZAHL-2</td>
<td>148</td>
<td>Korrespondenz - Zahl 2</td>
<td>Zahl</td>
<td>Zahl 2 aus Korrespondenz</td>
</tr>
<tr>
<td>FIRMA1</td>
<td>150</td>
<td>Person - Organisation</td>
<td>Text</td>
<td>Feld Organisation</td>
</tr>
<tr>
<td>FIRMA2</td>
<td>151</td>
<td>Person 2 - Organisation</td>
<td>Text</td>
<td>Feld Organisation der Person 2</td>
</tr>
<tr>
<td>GEBURTSDATUM1</td>
<td>152</td>
<td>Person - Geburtsdatum, ISO 8601</td>
<td>Text</td>
<td>Geburtsdatum Format JJJJ-MM-TT</td>
</tr>
<tr>
<td>GEBURTSJAHR1</td>
<td>153</td>
<td>Person - Geburtsjahr, 0000</td>
<td>IntZahl</td>
<td>Geburtsjahr (Jahr aus Geburtsdatum), 0000 wenn leer</td>
</tr>
<tr>
<td>GEBURTSJAHR1.1</td>
<td>154</td>
<td>Person - Geburtsjahr, '' wenn leer</td>
<td>IntZahl</td>
<td>Geburtsjahr (Jahr aus Geburtsdatum), ohne Eintrag wenn leer</td>
</tr>
<tr>
<td>GEBURTSJAHR1.2</td>
<td>155</td>
<td>Person - Geburtsjahr, 0 wenn leer</td>
<td>IntZahl</td>
<td>Geburtsjahr (Jahr aus Geburtsdatum), 0 wenn leer</td>
</tr>
<tr>
<td>GEBURTSJAHR1.3</td>
<td>156</td>
<td>Person - Alter</td>
<td>IntZahl</td>
<td>Alter der Person (aktuelles Jahr minus Geburtsjahr)</td>
</tr>
<tr>
<td>GEBURTSJAHR2</td>
<td>157</td>
<td>Person 2 - Geburtsjahr, '' wenn leer</td>
<td>IntZahl</td>
<td>Geburtsjahr (Jahr aus Geburtsdatum) Person 2, ohne Eintrag wenn leer</td>
</tr>
<tr>
<td>GEBURTSMONAT1</td>
<td>158</td>
<td>Person - Geburtsmonat, 00</td>
<td>Text</td>
<td>Geburtsmonat (Monat aus Geburtsdatum) zweistellig, '' wenn leer</td>
</tr>
<tr>
<td>GEBURTSMONAT1.1</td>
<td>159</td>
<td>Person - Geburtsmonat, '' wenn leer</td>
<td>IntZahl</td>
<td>Geburtsmonat (Monat aus Geburtsdatum), ohne Eintrag wenn leer</td>
</tr>
<tr>
<td>GEBURTSMONAT1.2</td>
<td>160</td>
<td>Person - Geburtsmonat, 0 wenn leer</td>
<td>IntZahl</td>
<td>Geburtsmonat (Monat aus Geburtsdatum), 0 wenn leer</td>
</tr>
<tr>
<td>GEBURTSTAG1</td>
<td>161</td>
<td>Person - Geburtstag, 00</td>
<td>Text</td>
<td>Geburtstag (Tag aus Geburtsdatum) zweistellig, '' wenn leer</td>
</tr>
<tr>
<td>GEBURTSTAG1.1</td>
<td>162</td>
<td>Person - Geburtstag, '' wenn leer</td>
<td>IntZahl</td>
<td>Geburtstag (Tag aus Geburtsdatum), ohne Eintrag wenn leer</td>
</tr>
<tr>
<td>GEBURTSTAG1.2</td>
<td>163</td>
<td>Person - Geburtstag, 0 wenn leer</td>
<td>IntZahl</td>
<td>Geburtstag (Tag aus Geburtsdatum), 0 wenn leer</td>
</tr>
<tr>
<td>GenSperre1</td>
<td>164</td>
<td>Person - gesperrt</td>
<td>Logic</td>
<td>Bei einer Personensperre wird &quot;gesperrt&quot; exportiert, ansonsten leer (kein Wert).</td>
</tr>
<tr>
<td>GESCHLECHT1</td>
<td>168</td>
<td>Person - Geschlechtscode</td>
<td>Text</td>
<td>Geschlechtscode, alphanumerisch (m=&quot;masculin&quot;, f=&quot;feminin&quot; oder leer)</td>
</tr>
<tr>
<td>GESCHLECHT2</td>
<td>169</td>
<td>Person 2 - Geschlechtscode</td>
<td>Text</td>
<td>Geschlechtscode von Person 2, alphanumerisch (m=&quot;masculin&quot;, f=&quot;feminin&quot; oder leer)</td>
</tr>
<tr>
<td>HAUSHALT1</td>
<td>170</td>
<td>Person - Haushalt-ID</td>
<td>IntZahl</td>
<td>tiefste Personen-ID aus Haushalt (0 wenn keine Haushaltsbeziehung vorhanden)</td>
</tr>
<tr>
<td>HAUSNR+ALPHA1</td>
<td>171</td>
<td>Adresse - Hausnummer mit Zusatz</td>
<td>Text</td>
<td>Hausnummer alphanumerisch, z.B. 102A</td>
</tr>
<tr>
<td>HAUSNR+ALPHA2</td>
<td>172</td>
<td>Adresse Person 2 - Hausnummer mit Zusatz</td>
<td>Text</td>
<td>Hausnummer alphanumerisch der Person 2, z.B. 102A</td>
</tr>
<tr>
<td>HAUSNRALPHA1</td>
<td>173</td>
<td>Adresse - Hausnummer-Zusatz (ohne Nummer)</td>
<td>Text</td>
<td>Hausnummer-Zusatz der Adresse (ohne numerischer Teil)</td>
</tr>
<tr>
<td>HAUSNRALPHA2</td>
<td>174</td>
<td>Adresse Person 2 - Hausnummer-Zusatz (ohne Nummer)</td>
<td>Text</td>
<td>Hausnummer-Zusatz der Adresse von Person 2 (ohne numerischer Teil)</td>
</tr>
<tr>
<td>HAUSNRNUM1</td>
<td>175</td>
<td>Adresse - Hausnummer numerischer Teil</td>
<td>IntZahl</td>
<td>Hausnummer der Adresse (ohne Zusatz)</td>
</tr>
<tr>
<td>HAUSNRNUM2</td>
<td>176</td>
<td>Adresse Person 2 - Hausnummer numerischer Teil</td>
<td>IntZahl</td>
<td>Hausnummer der Adresse von Person 2 (ohne Zusatz)</td>
</tr>
<tr>
<td>HERKUNFTART1</td>
<td>177</td>
<td>Person - Herkunftsart</td>
<td>Text</td>
<td>Herkunftsart</td>
</tr>
<tr>
<td>HERKUNFTEREIG1</td>
<td>178</td>
<td>Person - HerkunftsereignisID</td>
<td>Text</td>
<td>Ereignis-ID für die Herkunft der Person</td>
</tr>
<tr>
<td>HERKUNFTEPOS1</td>
<td>179</td>
<td>Person - HerkunftsereignispositionID</td>
<td>Text</td>
<td>Ereignispositions-ID für die Herkunft der Person</td>
</tr>
<tr>
<td>HERKUNFTART2</td>
<td>180</td>
<td>Person 2 - Herkunftsart</td>
<td>Text</td>
<td>Herkunftsart der Person 2</td>
</tr>
<tr>
<td>HERKUNFTEREIG2</td>
<td>181</td>
<td>Person 2 - HerkunftsereignisID</td>
<td>Text</td>
<td>Ereignis-ID für die Herkunft der Person 2</td>
</tr>
<tr>
<td>HERKUNFTEPOS2</td>
<td>182</td>
<td>Person 2 - HerkunftsereignispositionID</td>
<td>Text</td>
<td>Ereignispositions-ID für die Herkunft der Person 2</td>
</tr>
<tr>
<td>HEUTE</td>
<td>183</td>
<td>Festwert - aktuelles Datum</td>
<td>Datum</td>
<td>Produktionsdatum des Exports im Format TT.MM.JJJJ</td>
</tr>
<tr>
<td>JOBDATUM</td>
<td>184</td>
<td>HG-Job - Datum</td>
<td>Datum</td>
<td>Datum des Hintergrundjobs</td>
</tr>
<tr>
<td>JOBNR</td>
<td>185</td>
<td>HG-Job - Laufnummer</td>
<td>IntZahl</td>
<td>Laufnummer des Hintergrundjobs</td>
</tr>
<tr>
<td>JOBPOSNR</td>
<td>187</td>
<td>Zusagenfakturierung - Positionsnummer</td>
<td>IntZahl</td>
<td>Positionsnummer aus der Zusagenfakturierung</td>
</tr>
<tr>
<td>KANTON1</td>
<td>188</td>
<td>Adresse - Kanton</td>
<td>Text</td>
<td>Kanton zu der postalischen Adresse</td>
</tr>
<tr>
<td>KaufSperre1</td>
<td>189</td>
<td>Adresse - Kaufsperre</td>
<td>Logic</td>
<td>Bei einer Kaufsperre wird &quot;gesperrt&quot; exportiert, ansonsten leer (kein Wert).</td>
</tr>
<tr>
<td>KEINTRAG</td>
<td>190</td>
<td>Korrespondenz - Kommunikationseintrag (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>KKANAL</td>
<td>191</td>
<td>Korrespondenz - Kanal (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>KONTAKT1</td>
<td>192</td>
<td>Kontaktperson - Vorname und Nachname</td>
<td>Text</td>
<td>Vorname und Nachname der Kontaktperson einer Organisation</td>
</tr>
<tr>
<td>KONTAKT2</td>
<td>193</td>
<td>Kontaktperson 2 - Vorname und Nachname</td>
<td>Text</td>
<td>Vorname und Nachname der Kontaktperson einer Organisation (von Person 2)</td>
</tr>
<tr>
<td>KORRARTEN1</td>
<td>203</td>
<td>Person - Korrespondenzen</td>
<td>Text</td>
<td>Verwendete Korrespondenzen einer Person (kommagetrennt)</td>
</tr>
<tr>
<td>KORRNR</td>
<td>204</td>
<td>Korrespondenz - Interne Nummer</td>
<td>IntZahl</td>
<td>Interne Korrespondenznummer</td>
</tr>
<tr>
<td>LAND1</td>
<td>205</td>
<td>Adresse - Land (CH leer)</td>
<td>Text</td>
<td>Land, leer wenn &quot;CH&quot;</td>
</tr>
<tr>
<td>LAND1.1</td>
<td>206</td>
<td>Adresse - Land (CH ausgeschrieben)</td>
<td>Text</td>
<td>Land, leer wird für schweizer Enklaven und Lichtenstein je nach PLZ-/Kanton-Zugehörigkeit als DE, IT oder LI exportiert, Rest wird als CH exportiert.</td>
</tr>
<tr>
<td>LAND2</td>
<td>207</td>
<td>Adresse Person 2 - Land</td>
<td>Text</td>
<td>Land von Adresse der Person 2, leer wenn &quot;CH&quot;</td>
</tr>
<tr>
<td>leer</td>
<td>208</td>
<td>Festwert - leer</td>
<td>Text</td>
<td>leeres Feld</td>
</tr>
<tr>
<td>LF</td>
<td>209</td>
<td>Festwert - LF</td>
<td>Sys</td>
<td>Steuerzeichen &quot;line feed&quot;</td>
</tr>
<tr>
<td>MERKMALE1</td>
<td>210</td>
<td>Person - Merkmale</td>
<td>Text</td>
<td>Merkmale einer Person, kommagetrannt</td>
</tr>
<tr>
<td>FIRMA-VNAME-NAME</td>
<td>211</td>
<td>Person - Firmenname oder Vorname + Nachname bei Privat</td>
<td>Text</td>
<td>beim Kontakt und Firma Firmenname, beim Privat Vorname + Nachname</td>
</tr>
<tr>
<td>NACHNAME1</td>
<td>212</td>
<td>Person - Nachname</td>
<td>Text</td>
<td>Nachname</td>
</tr>
<tr>
<td>NACHNAME2</td>
<td>213</td>
<td>Person 2 - Nachname</td>
<td>Text</td>
<td>Nachname der Person 2</td>
</tr>
<tr>
<td>NAME1</td>
<td>214</td>
<td>Person - Nachname oder Firmenname</td>
<td>Text</td>
<td>Nachname, bei Personen mit Typ &quot;Organisation&quot; wird das Feld &quot;Organistion&quot; exportiert</td>
</tr>
<tr>
<td>NAME2</td>
<td>215</td>
<td>Person 2 - Nachname oder Firmenname</td>
<td>Text</td>
<td>Nachname der Person 2, bei Personen mit Typ &quot;Organisation&quot; wird das Feld &quot;Organistion&quot; exportiert</td>
</tr>
<tr>
<td>ORT1</td>
<td>216</td>
<td>Adresse - Ort</td>
<td>Text</td>
<td>Ortsbezeichnung in der postalischen Adresse</td>
</tr>
<tr>
<td>ORT2</td>
<td>217</td>
<td>Adresse Person 2 - Ort</td>
<td>Text</td>
<td>Ortsbezeichnung in der postalischen Adresse von Person 2</td>
</tr>
<tr>
<td>OE1</td>
<td>218</td>
<td>Person - OE oder Region</td>
<td>Text</td>
<td>Organisatorische Einheit oder Region (abhängig von Systemparameter &quot;oerg&quot;)</td>
</tr>
<tr>
<td>OE2</td>
<td>219</td>
<td>Person 2 - OE oder Region</td>
<td>Text</td>
<td>Organisatorische Einheit oder Regio von Person 2 (abhängig von Systemparameter &quot;oerg&quot;)</td>
</tr>
<tr>
<td>PAKETCODE</td>
<td>222</td>
<td>Botenroutierung - 1. Bund</td>
<td>Logic</td>
<td>Botenroutierung, Eintrag &quot;*&quot; beim 1. Bund</td>
</tr>
<tr>
<td>PAKETNUMMER</td>
<td>223</td>
<td>Botenroutierung - Paketnummer (numerisch)</td>
<td>IntZahl</td>
<td>Paketnummer für Botenroutierung, numerisch ('' wenn leer)</td>
</tr>
<tr>
<td>PAKETNUMMER1</td>
<td>224</td>
<td>Botenroutierung - Paketnummer (veraltet**)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>PAKETNUMMER2</td>
<td>225</td>
<td>Botenroutierung - Paketnummer (numerisch, 0 wenn leer)</td>
<td>Text</td>
<td>Paketnummer für Botenroutierung, numerisch (0 wenn leer)</td>
</tr>
<tr>
<td>PLZ1</td>
<td>226</td>
<td>Adresse - PLZ</td>
<td>Text</td>
<td>Postleitzahl der postalischen Adresse</td>
</tr>
<tr>
<td>PLZ2</td>
<td>227</td>
<td>Adresse Person 2 - PLZ</td>
<td>Text</td>
<td>Postleitzahl der postalischen Adresse von Person 2</td>
</tr>
<tr>
<td>PLZZ1</td>
<td>228</td>
<td>Adresse - PLZZ</td>
<td>IntZahl</td>
<td>Postleitzahl Zusatz der postalischen Adresse, Format frei</td>
</tr>
<tr>
<td>PLZZ1.1</td>
<td>229</td>
<td>Adresse - PLZZ (2-stellig)</td>
<td>IntZahl</td>
<td>Postleitzahl Zusatz der postalischen Adresse, numerisch 2-stellig</td>
</tr>
<tr>
<td>POSTFACH1</td>
<td>230</td>
<td>Adresse - Postfach</td>
<td>Text</td>
<td>Postfach-Eintrag (&quot;Postfach&quot; oder &quot;Postfach&quot; + Nr.)</td>
</tr>
<tr>
<td>POSTFACH2</td>
<td>231</td>
<td>Adresse Person 2 - Postfach</td>
<td>Text</td>
<td>Postfach-Eintrag (&quot;Postfach&quot; oder &quot;Postfach&quot; + Nr.) von Person 2</td>
</tr>
<tr>
<td>PUBLCD1</td>
<td>234</td>
<td>Person - Publikationen {1}</td>
<td>Text</td>
<td>Aktive Publikationen einer Person, kommagetrennt</td>
</tr>
<tr>
<td>PUBLIKATIONEN1</td>
<td>235</td>
<td>Zusagenfakturierung - Publikationen zu Zusage</td>
<td>Text</td>
<td>Publikationen zu einer aktiven Zusage</td>
</tr>
<tr>
<td>PUBLIKATIONEN1.1</td>
<td>236</td>
<td>Zusagenfakturierung - Publikationen zu Zusage (ereignisabhängig)</td>
<td>Text</td>
<td>Publikationen zu einer aktiven Zusage, wenn Ereignis 1 vorhanden ist</td>
</tr>
<tr>
<td>REFNUM2</td>
<td>241</td>
<td>Referenznummer zu ESR2</td>
<td>Text</td>
<td>Referenznummer zu ESR2</td>
</tr>
<tr>
<td>REFNUMKOMPAKT1</td>
<td>248</td>
<td>Formatierungsfrei Referenznummer zu ESR1</td>
<td>Text</td>
<td>Formatierungsfrei Referenznummer zu ESR1</td>
</tr>
<tr>
<td>SpendenSperre1</td>
<td>249</td>
<td>Adresse - Spendensperre</td>
<td>Logic</td>
<td>Bei einer Spendensperre wird &quot;gesperrt&quot; exportiert, ansonsten leer (kein Wert).</td>
</tr>
<tr>
<td>SPEZSPENDE_TOTAL1</td>
<td>250</td>
<td>Adresse - Spendetotal (life time) SPE,PPA</td>
<td>Zahl</td>
<td>Adresse - Spendetotal (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_ANZAHL1</td>
<td>251</td>
<td>Adresse - Anzahl Spenden (life time) SPE,PPA</td>
<td>IntZahl</td>
<td>Adresse - Anzahl Spenden (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_MAX1</td>
<td>252</td>
<td>Adresse - höchste Einzelspende (life time) SPE,PPA</td>
<td>Zahl</td>
<td>Adresse - höchste Einzelspende (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_MAXDAT1</td>
<td>253</td>
<td>Adresse - Datum der höchsten Spende (life time) SPE,PPA</td>
<td>Datum</td>
<td>Adresse - Datum der höchsten Spende (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_ERSTE1</td>
<td>254</td>
<td>Adresse - die erste Spende (life time) SPE,PPA</td>
<td>Zahl</td>
<td>Adresse - die erste Spende (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_ERSTEDAT1</td>
<td>255</td>
<td>Adresse - Datum der ersten Spende (life time) SPE,PPA</td>
<td>Datum</td>
<td>Adresse - Datum der ersten Spende (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_LETZTE1</td>
<td>256</td>
<td>Adresse - die letzte Spende (life time) SPE,PPA</td>
<td>Zahl</td>
<td>Adresse - die letzte Spende (life time) SPE,PPA</td>
</tr>
<tr>
<td>SPEZSPENDE_LETZTEDAT1</td>
<td>257</td>
<td>Adresse - Datum der letzten Spende (life time) SPE,PPA</td>
<td>Datum</td>
<td>Adresse - Datum der letzten Spende (life time) SPE,PPA</td>
</tr>
<tr>
<td>STATUS+ADRNUM1</td>
<td>268</td>
<td>Adresse - Status + Adressnummer</td>
<td>Text</td>
<td>Adresse - Status + Adressnummer</td>
</tr>
<tr>
<td>STATUS1</td>
<td>269</td>
<td>Adresse - Status</td>
<td>Text</td>
<td>Adresse - Status</td>
</tr>
<tr>
<td>STATUS2</td>
<td>271</td>
<td>2. Adresse - Status</td>
<td>Text</td>
<td>2. Adresse - Status</td>
</tr>
<tr>
<td>STD-E-MAIL2</td>
<td>273</td>
<td>2. Adresse - Standart E-Mail Adresse (Kanal = E-Mail)</td>
<td>Text</td>
<td>2. Adresse - Standart E-Mail Adresse (Kanal = E-Mail)</td>
</tr>
<tr>
<td>STRASSE-KURZ</td>
<td>274</td>
<td>Adresse - Kurzstrasse</td>
<td>Text</td>
<td>Adresse - Kurzstrasse</td>
</tr>
<tr>
<td>STRASSE1</td>
<td>275</td>
<td>Adresse - Strasse ohne Hausnr.</td>
<td>Text</td>
<td>Adresse - Strasse ohne Hausnr.</td>
</tr>
<tr>
<td>STRASSE2</td>
<td>277</td>
<td>2. Adresse - Strasse ohne Hausnr.</td>
<td>Text</td>
<td>2. Adresse - Strasse ohne Hausnr.</td>
</tr>
<tr>
<td>STRKURZ+HNRALPHA1</td>
<td>278</td>
<td>Adresse - Kurzstrasse + Hausnummer Alpha</td>
<td>Text</td>
<td>Adresse - Kurzstrasse + Hausnummer Alpha</td>
</tr>
<tr>
<td>TELEFON-NR1</td>
<td>279</td>
<td>Adresse - Telefonnummer ohne Vorwahlnummer (** veraltet)</td>
<td>Text</td>
<td>Adresse - Telefonnummer ohne Vorwahlnummer (veraltet, nicht mehr benutzen)</td>
</tr>
<tr>
<td>TELEFON-VW1</td>
<td>280</td>
<td>Adresse - Telefon-Vorwahlnummer (** veraltet)</td>
<td>Text</td>
<td>Adresse - Telefon-Vorwahlnummer (veraltet, nicht mehr benutzen)</td>
</tr>
<tr>
<td>TIT+VOR+NAME1</td>
<td>282</td>
<td>Adresse - Adresstitel + Vorname + Adressname</td>
<td>Text</td>
<td>Adresse - Adresstitel + Vorname + Adressname</td>
</tr>
<tr>
<td>TITEL1</td>
<td>283</td>
<td>Adresse - Adresstitel</td>
<td>Text</td>
<td>Adresse - Adresstitel</td>
</tr>
<tr>
<td>TITEL1.1</td>
<td>284</td>
<td>Adresse - Adresstitel (Zwischenraum am Ende)</td>
<td>Text</td>
<td>Adresse - Adresstitel (Zwischenraum am Ende)</td>
</tr>
<tr>
<td>TITEL2</td>
<td>285</td>
<td>2. Adresse - Adresstitel</td>
<td>Text</td>
<td>2. Adresse - Adresstitel</td>
</tr>
<tr>
<td>UMSAJE1A</td>
<td>286</td>
<td>Umsatz der Adresse im aktuellen Jahr für Ereignis1 aus Exportparameter, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSAJE1N</td>
<td>287</td>
<td>Umsatz der Adresse im aktuellen Jahr für 1. Ereignis aus Exportparameter, Format 9.99</td>
<td>Zahl</td>
<td>Umsatz der Adresse im aktuellen Jahr für 1. Ereignis aus Exportparameter, Format 9.99</td>
</tr>
<tr>
<td>UMSAJS1A</td>
<td>288</td>
<td>Umsatz der Adresse im aktuellen Jahr für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSAJS1AN</td>
<td>289</td>
<td>Netto Umsatz der Adresse im aktuellen Jahr für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSAJS1N</td>
<td>290</td>
<td>Umsatz der Adresse im aktuellen Jahr (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Umsatz der Adresse im aktuellen Jahr (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>UMSAJS1NN</td>
<td>291</td>
<td>Netto Umsatz der Adresse im aktuellen Jahr (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Netto Umsatz der Adresse im aktuellen Jahr (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>UMSLJE1A</td>
<td>292</td>
<td>Umsatz der Adresse in letzten aktiven Jahren für Ereignis1, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSLJE1N</td>
<td>293</td>
<td>Umsatz der Adresse in letzten aktiven Jahren für Ereignis1, numerisch, Format 9.99</td>
<td>Zahl</td>
<td>Umsatz der Adresse in letzten aktiven Jahren für Ereignis1, numerisch, Format 9.99</td>
</tr>
<tr>
<td>UMSLJS1A</td>
<td>294</td>
<td>Umsatz der Adresse in letzten aktiven Jahren für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSLJS1N</td>
<td>295</td>
<td>Umsatz der Adresse in letzten aktiven Jahren für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, numerisch, Format 9.99</td>
<td>Zahl</td>
<td>Umsatz der Adresse in letzten aktiven Jahren für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, numerisch, Format 9.99</td>
</tr>
<tr>
<td>UMSSTEUER-AKTJAHR1</td>
<td>296</td>
<td>1. Adresse - Steuerrelevanter Umsatz aktuelles Jahr</td>
<td>Zahl</td>
<td>1. Adresse - Steuerrelevanter Umsatz aktuelles Jahr</td>
</tr>
<tr>
<td>UMSSTEUER-VORJAHR1</td>
<td>297</td>
<td>1. Adresse - Steuerrelevanter Umsatz Vorjahr</td>
<td>Zahl</td>
<td>1. Adresse - Steuerrelevanter Umsatz Vorjahr</td>
</tr>
<tr>
<td>UMSSPE-VORJAHR1</td>
<td>298</td>
<td>1. Adresse - Spendeumsatz Vorjahr</td>
<td>Zahl</td>
<td>1. Adresse - Spendeumsatz Vorjahr</td>
</tr>
<tr>
<td>UMSTOTALS1N</td>
<td>299</td>
<td>Lifetimeumsatz für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen</td>
<td>Zahl</td>
<td>Adressumsatz Lifetime für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, numerisch, Format 9.99</td>
</tr>
<tr>
<td>UMSVJE1A</td>
<td>300</td>
<td>Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für Ereignis1,alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSVJE1N</td>
<td>301</td>
<td>Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für Ereignis1, numerisch, Format 9.99</td>
<td>Zahl</td>
<td>Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für Ereignis1, numerisch, Format 9.99</td>
</tr>
<tr>
<td>UMSVJS1A</td>
<td>302</td>
<td>Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSVJS1AN</td>
<td>303</td>
<td>Netto Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, alphanumerisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSVJS1N</td>
<td>304</td>
<td>Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>UMSVJS1NN</td>
<td>305</td>
<td>Netto Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, numerisch, Format 9.99</td>
<td>Zahl</td>
<td>Netto Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, numerisch, Format 9.99</td>
</tr>
<tr>
<td>UMSVVJS1A</td>
<td>306</td>
<td>Umsatz der Adresse im Vorvorjahr (=[aktuelles Jahr] -2) für die im Systemparameter &quot;UMEX&quot; definierten Umsatztypen, alphanumeisch, Format #,##9.[--</td>
<td>99]</td>
<td>Text</td>
</tr>
<tr>
<td>UMSVVJS1N</td>
<td>307</td>
<td>Umsatz der Adresse im Vorvorjahr (=[aktuelles Jahr] -2) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Umsatz der Adresse im Vorvorjahr (=[aktuelles Jahr] -2) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>UNI-KATEGORIE</td>
<td>310</td>
<td>provisorisch xxx (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>UNI-UCHF-MIT1</td>
<td>311</td>
<td>Adressenumsatz MIT im Vorjahr (Ereignis1) in CHF</td>
<td>Zahl</td>
<td>Adressenumsatz MIT im Vorjahr (Ereignis1) in CHF</td>
</tr>
<tr>
<td>UNI-UCHF-MPS1</td>
<td>312</td>
<td>Adressenumsatz MIT + PAT + SPE im Vorjahr (Ereignis1) in CHF</td>
<td>Zahl</td>
<td>Adressenumsatz MIT + PAT + SPE im Vorjahr (Ereignis1) in CHF</td>
</tr>
<tr>
<td>UNI-UCHF-PAT1</td>
<td>313</td>
<td>Adressenumsatz PAT im Vorjahr (Ereignis1) in CHF</td>
<td>Zahl</td>
<td>Adressenumsatz PAT im Vorjahr (Ereignis1) in CHF</td>
</tr>
<tr>
<td>UNI-UCHF-SPE1</td>
<td>314</td>
<td>Adressenumsatz SPE im Vorereignissjahr (Ereignis1) in CHF</td>
<td>Zahl</td>
<td>Adressenumsatz SPE im Vorereignissjahr (Ereignis1) in CHF</td>
</tr>
<tr>
<td>UNI-UEUR-MIT1</td>
<td>315</td>
<td>Adressenumsatz MIT im Vorereignissjahr (Ereignis1) in EUR</td>
<td>Zahl</td>
<td>Adressenumsatz MIT im Vorereignissjahr (Ereignis1) in EUR</td>
</tr>
<tr>
<td>UNI-UEUR-MPS1</td>
<td>316</td>
<td>Adressenumsatz MIT + PAT + SPE im Vorjahr (Ereignis1) in EUR</td>
<td>Zahl</td>
<td>Adressenumsatz MIT + PAT + SPE im Vorjahr (Ereignis1) in EUR</td>
</tr>
<tr>
<td>UNI-UEUR-PAT1</td>
<td>317</td>
<td>Adressenumsatz PAT im Vorereignissjahr (Ereignis1) in EUR</td>
<td>Zahl</td>
<td>Adressenumsatz PAT im Vorereignissjahr (Ereignis1) in EUR</td>
</tr>
<tr>
<td>UNI-UEUR-SPE1</td>
<td>318</td>
<td>Adressenumsatz SPE im Vorereignissjahr (Ereignis1) in EUR</td>
<td>Zahl</td>
<td>Adressenumsatz SPE im Vorereignissjahr (Ereignis1) in EUR</td>
</tr>
<tr>
<td>UNI-UMSATZ-MPPS1</td>
<td>319</td>
<td>Adressenumsatz MIT + PAT + PPA + SPE im Vorjahr</td>
<td>Zahl</td>
<td>Adressenumsatz MIT + PAT + PPA + SPE im Vorjahr</td>
</tr>
<tr>
<td>UNI-UMSATZ-MPS1.1</td>
<td>320</td>
<td>Adressenumsatz MIT + PAT + SPE im Vorjahr</td>
<td>Zahl</td>
<td>Adressenumsatz MIT + PAT + SPE im Vorjahr</td>
</tr>
<tr>
<td>UNI-ZUSTYP1</td>
<td>321</td>
<td>Zusage - Typ UNICEF Format NEU-BEZAHLT / NEU / NACHFAKTURIERUNG</td>
<td>Text</td>
<td>Zusage - Typ UNICEF Format NEU-BEZAHLT / NEU / NACHFAKTURIERUNG</td>
</tr>
<tr>
<td>VERDANK-AN</td>
<td>322</td>
<td>verdank an (Kontakt/Spender)</td>
<td>Text</td>
<td>verdank an (Kontakt/Spender)</td>
</tr>
<tr>
<td>VerdMehrfach</td>
<td>323</td>
<td>Textblock: Verdankungstext</td>
<td>Text</td>
<td>Textblock: Verdankungstext</td>
</tr>
<tr>
<td>VERKVER</td>
<td>324</td>
<td>Verkaufsverantwortlicher Bezirk</td>
<td>Text</td>
<td>Verkaufsverantwortlicher Bezirk</td>
</tr>
<tr>
<td>VORNAME1</td>
<td>325</td>
<td>Person - Vorname</td>
<td>Text</td>
<td>Person - Vorname der Person</td>
</tr>
<tr>
<td>VNAME1</td>
<td>326</td>
<td>Person - Vorname, bei Organisation leer (** veraltet)</td>
<td>Text</td>
<td>Person - Vorname der Person, bei Organisation leer, ** veraltet, nicht mehr verwenden</td>
</tr>
<tr>
<td>VORNAME2</td>
<td>327</td>
<td>2. Person - Vorname</td>
<td>Text</td>
<td>2. Person - Vorname der Person</td>
</tr>
<tr>
<td>WHG1</td>
<td>329</td>
<td>Währung für Betrag1</td>
<td>Text</td>
<td>Währung für Betrag1</td>
</tr>
<tr>
<td>WHG2</td>
<td>330</td>
<td>Währung für Betrag2</td>
<td>Text</td>
<td>Währung für Betrag2</td>
</tr>
<tr>
<td>xxx</td>
<td>332</td>
<td>xxx (** veraltet)</td>
<td>Text</td>
<td>** nicht mehr verwenden (veraltet)</td>
</tr>
<tr>
<td>ZAHLUNGSPE1_1</td>
<td>333</td>
<td>1. Adresse - 1. jüngste Zahlung SPE</td>
<td>Zahl</td>
<td>1. Adresse - 1. jüngste Zahlung SPE</td>
</tr>
<tr>
<td>ZAHLUNGSPE1_2</td>
<td>334</td>
<td>1. Adresse - 2. jüngste Zahlung SPE1.Adresse -</td>
<td>Zahl</td>
<td>1. Adresse - 2. jüngste Zahlung SPE1.Adresse -</td>
</tr>
<tr>
<td>ZAHLUNGSPE1_3</td>
<td>335</td>
<td>1. Adresse - 3. jüngste Zahlung SPE</td>
<td>Zahl</td>
<td>1. Adresse - 3. jüngste Zahlung SPE</td>
</tr>
<tr>
<td>ZAHLUNGSPEDAT1_1</td>
<td>336</td>
<td>1. Adresse - 1. jüngste Zahlungsdatum SPE</td>
<td>Datum</td>
<td>1. Adresse - 1. jüngste Zahlungsdatum SPE</td>
</tr>
<tr>
<td>ZAHLUNGSPEDAT1_2</td>
<td>337</td>
<td>1. Adresse - 2. jüngste Zahlungsdatum SPE</td>
<td>Datum</td>
<td>1. Adresse - 2. jüngste Zahlungsdatum SPE</td>
</tr>
<tr>
<td>ZAHLUNGSPEDAT1_3</td>
<td>338</td>
<td>1. Adresse - 3. jüngste Zahlungsdatum SPE</td>
<td>Datum</td>
<td>1. Adresse - 3. jüngste Zahlungsdatum SPE</td>
</tr>
<tr>
<td>ZAHLUNGSPE1_F</td>
<td>339</td>
<td>1. Adresse - älteste Zahlung für Personenstatus S</td>
<td>Zahl</td>
<td>1. Adresse - älteste Zahlung für Personenstatus S</td>
</tr>
<tr>
<td>ZAHLUNGSPEDAT1_F</td>
<td>340</td>
<td>1. Adresse - älteste Zahlungsdatum für Personenstatus S</td>
<td>Datum</td>
<td>1. Adresse - älteste Zahlungsdatum für Personenstatus S</td>
</tr>
<tr>
<td>ZUS-AKQUISITION</td>
<td>341</td>
<td>Zusage - Akquisition</td>
<td>Text</td>
<td>Zusage - Akquisition</td>
</tr>
<tr>
<td>ZUS-BANKNAME1</td>
<td>344</td>
<td>Zusage - Name der Bank</td>
<td>Text</td>
<td>Zusage - Name der Bank</td>
</tr>
<tr>
<td>ZUS-BEZAHLT1</td>
<td>345</td>
<td>Zusage bezahlt (Ereignisjahr - Ereignis1)</td>
<td>Logic</td>
<td>Wenn die zusage bezahlt ist wird &quot;ja&quot; exportiert, ansonsten &quot;nein&quot;</td>
</tr>
<tr>
<td>ZUS-BEZBISJAHR1</td>
<td>346</td>
<td>Zusage - Beitragsjahr</td>
<td>IntZahl</td>
<td>Zusage - Beitragsjahr</td>
</tr>
<tr>
<td>ZUS-EINJAHR1</td>
<td>349</td>
<td>Zusage - Eintrittsajhr</td>
<td>IntZahl</td>
<td>Zusage - Eintrittsajhr</td>
</tr>
<tr>
<td>ZUS-EINJAHR1.1</td>
<td>350</td>
<td>Zusage - Eintrittsajhr (Format 9999)</td>
<td>IntZahl</td>
<td>Zusage - Eintrittsajhr (Format 9999)</td>
</tr>
<tr>
<td>ZUS-EINJAHR1.2</td>
<td>351</td>
<td>Zusage - Heute minus Eintrittsjahr</td>
<td>IntZahl</td>
<td>Zusage - Heute minus Eintrittsjahr</td>
</tr>
<tr>
<td>ZUS-RATEN1</td>
<td>352</td>
<td>Zusage - Anzahl Raten / gewünschte Teilzahlungen aus aktuelle Zusagekarte</td>
<td>Text</td>
<td>Zusage - Anzahl Raten / gewünschte Teilzahlungen aus aktuelle Zusagekarte</td>
</tr>
<tr>
<td>ZUS-RATEN1-N</td>
<td>353</td>
<td>Zusage - ZUS-RATEN1 (wenn '?' dann N)</td>
<td>Text</td>
<td>Zusage - ZUS-RATEN1 (wenn '?' dann N)</td>
</tr>
<tr>
<td>ZUS-RATEN1-1</td>
<td>354</td>
<td>Zusage - ZUS-RATEN1 (wenn '?' dann 1)</td>
<td>Text</td>
<td>Zusage - ZUS-RATEN1 (wenn '?' dann 1)</td>
</tr>
<tr>
<td>ZUS-SEKTION1</td>
<td>356</td>
<td>Zusage - Sektion</td>
<td>Text</td>
<td>Zusage - Sektion</td>
</tr>
<tr>
<td>ZUS-SEKTION1.1</td>
<td>357</td>
<td>Zusage - Sektion, wenn existiert nicht dann '?'</td>
<td>Text</td>
<td>Zusage - Sektion, wenn existiert nicht dann '?'</td>
</tr>
<tr>
<td>ZUS-VBETRAG1</td>
<td>358</td>
<td>Zusage - versprochener Betrag aus aktuelle Zusagekarte</td>
<td>Zahl</td>
<td>Zusage - versprochener Betrag aus aktuelle Zusagekarte</td>
</tr>
<tr>
<td>ZUS-ZMOD1</td>
<td>360</td>
<td>Zusage - Zahlungsmode</td>
<td>Text</td>
<td>Zusage - Zahlungsmode</td>
</tr>
<tr>
<td>ZUS-NXBELASTUNG1</td>
<td>362</td>
<td>Zusage - nächstes Belastung</td>
<td>Datum</td>
<td>Zusage - nächstes Belastung</td>
</tr>
<tr>
<td>ZusagenSperre1</td>
<td>363</td>
<td>Adresse - Zusagensperre</td>
<td>Logic</td>
<td>Bei einer Zusagensperre wird &quot;gesperrt&quot; exportiert, ansonsten leer (kein Wert).</td>
</tr>
<tr>
<td>ZUSAGESTATUS1</td>
<td>365</td>
<td>Adresse - Zusagestatus (Format '/Z')</td>
<td>Text</td>
<td>Adresse - Zusagestatus (Format '/Z')</td>
</tr>
<tr>
<td>ZUSARTEN1</td>
<td>370</td>
<td>1. Adresse - Zusagearten</td>
<td>Text</td>
<td>1. Adresse - Zusagearten</td>
</tr>
<tr>
<td>ZUSATZ1</td>
<td>371</td>
<td>Adresszusatz (name2 c/o...)</td>
<td>Text</td>
<td>Adresszusatz (name2, c/o...)</td>
</tr>
<tr>
<td>ZUSATZ1oKONTAKT1</td>
<td>372</td>
<td>ZUSATZ1 oder wenn ZUSATZ1 ist leer dann KONTAKT1</td>
<td>Text</td>
<td>ZUSATZ1 oder wenn ZUSATZ1 ist leer dann KONTAKT1</td>
</tr>
<tr>
<td>ZUSATZ2</td>
<td>373</td>
<td>2. Adresse - Name2 von Adresse</td>
<td>Text</td>
<td>2. Adresse - Name2 von Adresse</td>
</tr>
<tr>
<td>ZUSFAKT-FAKTDAT</td>
<td>374</td>
<td>Neues Fakturierungs-/Zähllauf-Datum</td>
<td>Datum</td>
<td>Neues Fakturierungs-/Zähllauf-Datum</td>
</tr>
<tr>
<td>ZUSFMULTI</td>
<td>375</td>
<td>Multipaten</td>
<td>Logic</td>
<td>Wenn es sich um einen Multipaten (mehrere Patenschaften) handelt, wird &quot;JA&quot; exportiert, ansonsten &quot;NEIN&quot;</td>
</tr>
<tr>
<td>ZUSFTEXT</td>
<td>376</td>
<td>Zusage - Bezeichnung</td>
<td>Text</td>
<td>Zusage - Bezeichnung</td>
</tr>
<tr>
<td>ZUS-GRUPPEANREDE1</td>
<td>377</td>
<td>Zusage - Gruppeanrede</td>
<td>Text</td>
<td>Zusage - Gruppeanrede</td>
</tr>
<tr>
<td>ZUS-GRUPPENAMEN1</td>
<td>378</td>
<td>Zusage - Gruppenamen</td>
<td>Text</td>
<td>Zusage - Gruppenamen</td>
</tr>
<tr>
<td>Beziehungsadresse-Titel</td>
<td>379</td>
<td>1. Adresse: Beziehungsadresse {1} - {2}</td>
<td>Text</td>
<td>1. Adresse: Beziehungsadresse {1} - {2}</td>
</tr>
<tr>
<td>Zusage: Gruppe-Teilnehmer</td>
<td>380</td>
<td>{1}. Gruppe-Teilnehmer: {2}</td>
<td>Text</td>
<td>{1}. Gruppe-Teilnehmer: {2}</td>
</tr>
<tr>
<td>P2P-KAMPAGNETITEL</td>
<td>381</td>
<td>P2P-KAMPAGNETITEL</td>
<td>Text</td>
<td>P2P-KAMPAGNETITEL</td>
</tr>
<tr>
<td>P2P-INITIATORS</td>
<td>382</td>
<td>P2P-INITIATORS</td>
<td>Text</td>
<td>P2P-INITIATORS</td>
</tr>
<tr>
<td>ADRUMS-VORJAHR-OHNE3Z</td>
<td>383</td>
<td>Umsatz der Adresse ohne Drittzahlerumsatz im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Umsatz der Adresse ohne Drittzahlerumsatz im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>ADRUMS-VORJAHR-NUR3Z</td>
<td>384</td>
<td>Drittzahlerumsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Drittzahlerumsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>BESCHENKTEUMS-VORJAHR</td>
<td>385</td>
<td>Beschenkte Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
<td>Zahl</td>
<td>Beschenkte Umsatz der Adresse im Vorjahr ohne aktuelles Jahr (=[aktuelles Jahr] -1) (Systemparameter &quot;UMEX&quot; Umsatztypen)</td>
</tr>
<tr>
<td>ZUS-AKQUIEREIGNIS</td>
<td>386</td>
<td>Zusage - Akquisitionsereignis</td>
<td>Text</td>
<td>Zusage - Akquisitionsereignis</td>
</tr>
<tr>
<td>ZUS-AKQUIEREIGNISPOSITION</td>
<td>387</td>
<td>Zusage - Akquisitionsereignis-Position</td>
<td>Text</td>
<td>Zusage - Akquisitionsereignis-Position</td>
</tr>
<tr>
<td>Externe Kunden-Nr.</td>
<td>388</td>
<td>1. Adresse: Externe Kunden-Nr., Quelle: {1}</td>
<td>Text</td>
<td>1. Adresse: Externe Kunden-Nr., Quelle: {1}</td>
</tr>
<tr>
<td>Adresse</td>
<td>389</td>
<td>Adresse, Typ: {1}, Format: {2}, Zusatzquelle: {3}</td>
<td>Text</td>
<td>Adresse, Typ: {1}, Format: {2}, Zusatzquelle: {3}</td>
</tr>
<tr>
<td>ZUS-ALLE</td>
<td>390</td>
<td>Zusagen - alle Pro Person</td>
<td>Text</td>
<td>Zusagen - alle Pro Person</td>
</tr>
<tr>
<td>ZUS-ZMOD-ALLE</td>
<td>391</td>
<td>Zusagen Zahlungsarten - alle pro Person</td>
<td>Text</td>
<td>Zusagen Zahlungsarten - alle pro Person</td>
</tr>
<tr>
<td>ZUS-VER-BETRAG-ALLE</td>
<td>392</td>
<td>Zusagen Versprochener Betrag - alle pro Person</td>
<td>Text</td>
<td>Zusagen Versprochener Betrag - alle pro Person</td>
</tr>
<tr>
<td>ZUS-RATEN-ALLE</td>
<td>393</td>
<td>Zusagen Anzahl Raten - alle pro Person</td>
<td>Text</td>
<td>Zusagen Anzahl Raten - alle pro Person</td>
</tr>
<tr>
<td>ZUS-BEZ-BETRAG-ALLE</td>
<td>394</td>
<td>Zusagen bezahlter Betrag - alle pro Person</td>
<td>Text</td>
<td>Zusagen bezahlter Betrag - alle pro Person</td>
</tr>
<tr>
<td>ZUS-AKT-INAKT-ALLE</td>
<td>395</td>
<td>Zusagen aktive/inaktive - alle pro Person</td>
<td>Text</td>
<td>Zusagen aktive/inaktive - alle pro Person</td>
</tr>
<tr>
<td>ZUS-EINTRITT-ALLE</td>
<td>396</td>
<td>Zusagen Eintritte - alle pro Person</td>
<td>Text</td>
<td>Zusagen Eintritte - alle pro Person</td>
</tr>
<tr>
<td>ZUS-AUSTRITT-ALLE</td>
<td>397</td>
<td>Zusagen Austritte - alle pro Person</td>
<td>Text</td>
<td>Zusagen Austritte - alle pro Person</td>
</tr>
<tr>
<td>ZUS-AKQUI-ALLE</td>
<td>398</td>
<td>Zusagen Akquicode - alle pro Person</td>
<td>Text</td>
<td>Zusagen Akquicode - alle pro Person</td>
</tr>
<tr>
<td>Zusagenfakturierung - ESR-Zeile</td>
<td>399</td>
<td>Zusagenfakturierung - ESR-Zeile: {1}, Betrag: {2}, End-Zeichen: {3}</td>
<td>Text</td>
<td>Zusagenfakturierung - ESR-Zeile: {1}, Betrag: {2}, End-Zeichen: {3}</td>
</tr>
<tr>
<td>Formatierte Adresszeilen</td>
<td>402</td>
<td>Person: Adresszeilen {1}x{2}, Personen-ID: {3}, {4} Funktion</td>
<td>Text</td>
<td>Person: Adresszeilen {1}x{2}, Personen-ID: {3}, {4} Funktion</td>
</tr>
<tr>
<td>Formatierte Adresszeilen</td>
<td>403</td>
<td>Weitere Person: Adresszeilen {1}x{2}, Personen-ID: {3}, {4} Funktion (** veraltet)</td>
<td>Text</td>
<td>Weitere Person: Adresszeilen {1}x{2}, Personen-ID: {3}, {4} Funktion (** veraltet)</td>
</tr>
<tr>
<td>Beziehung-Umsatz</td>
<td>404</td>
<td>1. Adresse: Beziehung-Umsatz im Jahr: {1}, Umsatztyp: {2}</td>
<td>Zahl</td>
<td>1. Adresse - Beziehung-Umsatz im Jahr {1}, Umsatztyp {2}</td>
</tr>
<tr>
<td>Merkmal mit Wert</td>
<td>405</td>
<td>Merkmal {1} mit Wert</td>
<td>Text</td>
<td>1. Adresse - Merkmal {1} mit Wert</td>
</tr>
<tr>
<td>Botensortierung-GDZ</td>
<td>406</td>
<td>Botensortierung-GDZ</td>
<td>Text</td>
<td>Botensortierung-GDZ</td>
</tr>
<tr>
<td>ANLASS-WERT-AKT-JAHR</td>
<td>407</td>
<td>Anlass - Responswert aktuelles Jahr</td>
<td>Zahl</td>
<td>Anlass - Responswert aktuelles Jahr</td>
</tr>
<tr>
<td>ANLASS-WERT-VOR-JAHR</td>
<td>408</td>
<td>Anlass - Responswert Vorjahr</td>
<td>Zahl</td>
<td>Anlass - Responswert Vorjahr</td>
</tr>
<tr>
<td>Kurzanrede</td>
<td>409</td>
<td>Anrede mit Anredeset {1}</td>
<td>Text</td>
<td>Anrede mit Anredeset {1}</td>
</tr>
<tr>
<td>1. Adresse - Zusage verschiedene Felder</td>
<td>410</td>
<td>1. Adresse - {1} Zusage {2}, Feld: {3} mit Format: {4}</td>
<td>Text</td>
<td>1. Adresse - {1} Zusage {2}, Feld: {3} mit Format: {4}</td>
</tr>
<tr>
<td>Segment</td>
<td>411</td>
<td>voller Pfad des Segments</td>
<td>Text</td>
<td>voller Pfad des Segments</td>
</tr>
<tr>
<td>Adressat Einzahl/Mehrzahl</td>
<td>412</td>
<td>Adressat Einzahl/Mehrzahl</td>
<td>Text</td>
<td>Adressat Einzahl/Mehrzahl</td>
</tr>
<tr>
<td>6-Stellige PLZ CH-Post (nicht für Adressierung)</td>
<td>413</td>
<td>6-Stellige PLZ CH-Post (nicht für Adressierung)</td>
<td>Text</td>
<td>6-Stellige PLZ CH-Post (nicht für Adressierung)</td>
</tr>
<tr>
<td>Saferpay-Id</td>
<td>414</td>
<td>Saferpay-Id mit Transaktionen im Jahr {1}</td>
<td>Text</td>
<td>Saferpay-Id mit Transaktionen im Jahr {1}</td>
</tr>
<tr>
<td>Anzahl/Responsbetrag Ereignisse</td>
<td>415</td>
<td>{1} {2} Ereignisse, Jahr: {3}, Ereignissituation: {4}, Umsatztyp: {5}</td>
<td>Zahl</td>
<td>Anzahl/Responsbetrag der Ereignisse im Jahr (Lifetime wenn Jahr leer) mit Ereignissituation und Umsatztyp</td>
</tr>
<tr>
<td>Erstes/Letztes Ereignisdatum</td>
<td>416</td>
<td>{1} Ereignisdatum, Typ: {2}, Ereignissituation: {3}, Umsatztyp: {4}</td>
<td>Datum</td>
<td>Erstes/Letztes Datum den Ereignissen mit Ereignissituation und Umsatztyp</td>
</tr>
<tr>
<td>Höchster/Niedrigster/Erster/Letzter Responswert</td>
<td>417</td>
<td>{1} Responswert, Ereignissituation: {2}, Umsatztyp: {3}</td>
<td>Zahl</td>
<td>Höchster/Niedrigster/Erster/Letzter Responswert aller Ereignisse mit Ereignissituation und Umsatztyp</td>
</tr>
<tr>
<td>Person Erfassungs-/Änderungs-Datum</td>
<td>418</td>
<td>{1}-Datum der Person</td>
<td>Datum</td>
<td>Erfassungs-/Änderungs-Datum der Person</td>
</tr>
<tr>
<td>Personenquelle</td>
<td>419</td>
<td>Personenquelle</td>
<td>Text</td>
<td>Personenquelle</td>
</tr>
<tr>
<td>Formatierte Zusagen</td>
<td>420</td>
<td>Formatierte Zusagen: {1}</td>
<td>Text</td>
<td>Formatierte Zusagen. Bei mehreren Zusagen werden mehrere Spalten erstellt</td>
</tr>
<tr>
<td>Anzahl aktiver Beziehungen</td>
<td>421</td>
<td>Anzahl aktiver Beziehungen mit Beziehung: {1}</td>
<td>IntZahl</td>
<td>Anzahl aktiver Beziehungen mit Beziehung: {1}</td>
</tr>
<tr>
<td>Person-/Kanal-/Adress-Sperre</td>
<td>422</td>
<td>{1}-Sperre, Kanal: {2} (std. Adresse)</td>
<td>Text</td>
<td>Person-/Kanal-/Adress-Sperre pro Kanal und bei Adressperre für Standardadresse</td>
</tr>
<tr>
<td>Recency Kategorie</td>
<td>423</td>
<td>Recency Kategorie für Ereignissituation: {1} und Umsatztyp: {2}</td>
<td>Text</td>
<td>Recency Kategorie aus den Ereignissen mit Ereignissituation und Umsatztyp. Mögliche Werte: neu, erneut, nicht erneut, lapsed, ohne Zahlung</td>
</tr>
<tr>
<td>Merkmal</td>
<td>424</td>
<td>Merkmal {1}</td>
<td>Text</td>
<td>Merkmale {1}</td>
</tr>
<tr>
<td>Personenstatus</td>
<td>425</td>
<td>Personenstatus {1}</td>
<td>Text</td>
<td>Personenstatus {1}</td>
</tr>
<tr>
<td>ZUSAPOS-BEZ</td>
<td>426</td>
<td>Zusagenfakturierung - Positionsnummer und Beschreibung</td>
<td>Text</td>
<td>Zusagenfakturierung - Positionsnummer und Beschreibung</td>
</tr>
<tr>
<td>Kumulierter/Letzter Responswert</td>
<td>430</td>
<td>{1} Responswert Ereignis: {2} im Zeitraum {3}-{4}</td>
<td>Zahl</td>
<td>{1} Responswert zu Ereignis: {2} im Zeitraum {3}-{4}</td>
</tr>
<tr>
<td>Ereignis ID/Beschreibung</td>
<td>431</td>
<td>Erste Response Ereignis-{1} in den letzten {2} Monaten, Umsatztyp: {3}</td>
<td>Text</td>
<td>Exportiert erstes Response-Ereignis in den letzten Anzahl Monaten eingeschränkt nach Umsatztyp. Das Ereignis kann wahlweise als Ereignis-ID oder als Ereignisbeschreibung exportiert werden.</td>
</tr>
<tr>
<td>ESR-Feld</td>
<td>432</td>
<td>ESR-{1}: {2}, Betrag: {3}</td>
<td>Text</td>
<td>Exportiert wahlweise ESR-Zeile/Konto/Referenznummer {1} für das n-te Segmentereignis {2} und mit dem Betrag {3} entweder explizit offen, explizit 0 oder gemäss Vorgabe (normal). Die Betragsvorgabe wird im Segmentereignis, bzw. beim Filterexport als Eingabeparameter definiert. Beim Export der Zusagefakturierung gilt das erste Ereignis als Zusageereignis, das zweite als optionaler Spendenereignis.</td>
</tr>
<tr>
<td>QR-Rechnungsempänger</td>
<td>433</td>
<td>QR-Rechnungsempänger {1}</td>
<td>Text</td>
<td>Bei QR-Rechnung wahlweise 3 formatierte Zeilen oder alle strukturierten Felder</td>
</tr>
<tr>
<td>QR-Rechnungssteller</td>
<td>434</td>
<td>QR-Rechnungsteller {1}</td>
<td>Text</td>
<td>Bei QR-Rechnung wahlweise 2/3 formatierte Zeilen oder alle strukturierten Felder</td>
</tr>
<tr>
<td>SPRACHCODEUNIV</td>
<td>438</td>
<td>Adresse - Sprachcode</td>
<td>Text</td>
<td>Person: erste oder zweite, Typ: Formattierung</td>
</tr>
</tbody>
</table>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.exportformat.html" title="Exportformate">Exportformat</RouteLink></p>
</div></template>


